import { SignUp, Login, PrivacyPolicy } from 'src/Pages';

export interface IPublicRoutes {
  path: string;
  title: string;
  element: any;
}

export const PublicRoutes: IPublicRoutes[] = [
  {
    path: '/login',
    title: 'Login',
    element: <Login />,
  },
  {
    path: '/register',
    title: 'Register',
    element: <SignUp />,
  },
  {
    path: '/privacy-policy',
    title: 'Privacy Policy',
    element: <PrivacyPolicy />,
  },
];
